import { createSlice } from "@reduxjs/toolkit";

const cleanBanner = {
  titulo: "",
  imagemSelecionada: "",
  pecuaria: false,
  agricultura: false,
  patrocinador: "",
  direcionarBanner: "",
  linkRedirecionamento: "",
  dataPublicacao: null,
  publicarAgora: false,
  dataExclusao: null,
  filiaisSelecionadas: [],
  regionaisSelecionadas: [],
  produtoSelecionado: null,
  servicoSelecionado: null,
};

export const reducer = createSlice({
  name: "reducer",
  initialState: {
    load: 0,
    user: {},
    token: "",
    paginaAtual: "",
    paginaAnterior: "",
    telasPermitidas: [],
    toastMessage: "",
    toastType: "",
  },
  reducers: {
    setUser: (state, newUser) => {
      state.user = newUser.payload;
    },
    incrementLoad: (state) => {
      state.load++;
    },
    decrementLoad: (state) => {
      state.load--;
    },
    setToken: (state, newToken) => {
      state.token = newToken.payload;
    },
    setPaginaAtual: (state, newPaginaAtual) => {
      state.paginaAnterior = state.paginaAtual;
      state.paginaAtual = newPaginaAtual.payload;
    },

    setTelasPermitidas: (state, newTelasPermitidas) => {
      state.telasPermitidas = newTelasPermitidas.payload;
    },

    clearReducer: (state) => {
      state.load = 0;
      state.user = {};
      state.token = "";
      state.paginaAtual = "";
      state.paginaAnterior = "";
      state.telasPermitidas = [];
    },
    setToastMessage: (state, newToastMessage) => {
      state.toastMessage = newToastMessage.payload;
    },
    setToastType: (state, newToastType) => {
      state.toastType = newToastType.payload;
    },
  },
});

export const {
  setUser,
  incrementLoad,
  decrementLoad,
  setToken,
  clearReducer,
  setPaginaAtual,
  setTelasPermitidas,
  toastMessage,
  setToastMessage,
  toastType,
  setToastType,
} = reducer.actions;

export default reducer.reducer;
